(function(module){
    "use strict";

    module.component('brandInfo', {
        template: require('./brandInfoComponent.html'),
        bindings: {
            market: "<",
            molecule: "<"
        },
        controller: ['$scope', function(this: $TSFixMe, $scope: $TSFixMe) {
            var $ctrl = this;

        }]
    })

})(angular.module('topline.modules'));